import * as M from "@discovery/prelude/lib/data/maybe";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _availableLocations, _user } from "@discovery/common-dplus/lib/state";
import * as styles from "./styles.css";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import { navigateTo } from "../../../utils/common";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { Link, LinkKind } from "../../../components/atoms/link";
import { Icon, Icons } from "../../../components/atoms/icon";
import Strings from "../../../utils/hardcoded.json";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
const error404 = require("./error404.png");
export const ErrorPageView = () => {
    const [userM] = useGlobalState(_user);
    const [availableLocations] = useGlobalState(_availableLocations);
    const locationM = M.map((user) => user.attributes.currentLocationTerritory, userM);
    return (React.createElement(RenderMaybe, null, M.map((location) => availableLocations.includes(location) ? (React.createElement("div", { className: styles.errorPage },
        React.createElement(Typography, { classNameM: M.of(styles.errorText), variant: HeaderVariants.headingFour, tag: Tags.h4 },
            React.createElement(React.Fragment, null, Strings.ERROR)),
        React.createElement("img", { src: error404, alt: "404" }),
        React.createElement(Typography, { classNameM: M.of(styles.errorMsg), variant: HeaderVariants.headingTwo, tag: Tags.h1 },
            React.createElement(React.Fragment, null, Strings.ERROR_PAGE_DESCRIPTION)),
        React.createElement(Typography, { classNameM: M.of(styles.getBackMsg), variant: HeaderVariants.headingTwo, tag: Tags.h1 },
            React.createElement(React.Fragment, null, Strings.GET_BACK)),
        React.createElement("div", { className: styles.button, onClick: () => navigateTo(config.standardPageRouteFragments.home) }, Strings.BACK_TO_HOME_PAGE))) : (React.createElement("div", { className: styles.errorPage },
        React.createElement(Icon, { type: Icons.GeoMask }),
        React.createElement(Typography, { classNameM: M.of(styles.errorMsg), variant: HeaderVariants.headingTwo, tag: Tags.h1 },
            React.createElement(React.Fragment, null, Strings.GEO_RESTRICTION_MSG)),
        React.createElement(Typography, { classNameM: M.of(styles.getBackMsg), variant: HeaderVariants.headingTwo, tag: Tags.h1 },
            React.createElement(React.Fragment, null, Strings.GEO_RESTRICTION_GET_INTOUCH)),
        React.createElement(Link, { href: `mailTo:${"hello@discovery.com"}`, kind: LinkKind.external, openInNewWindow: true },
            React.createElement("div", { className: styles.button },
                " ",
                Strings.EMAIL_SUPPORT)))), locationM)));
};

